<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <circle fill="currentColor" cx="12" cy="12" r="6"/>
    </svg>
</template>

<script>
export default {
    name: 'CircleIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
